export default __webpack_public_path__ + "static/joko-app-screenshot-home-1-en@2x-a437591a17b22ad3f9118e3db16016e3.webp";